const proposalDialogConstantsEN = {
  proposalRequestDialogTitle: 'Proposal Request',
  proposalRequestStatus: 'REQUEST STATUS',
  videoDetailsTitle: 'VIDEO DETAILS',
  videoDetailsThumbnailLabel: 'THUMBNAIL',
  videoDetailsVideoTitleLabel: 'VIDEO TITLE',
  videoDetailsDurationLabel: 'DURATION',
  videoDetailsDescriptionLabel: 'DESCRIPTION',
  videoDetailsPublishedDateLabel: 'PUBLISHED DATE',
  userDetailsTitle: 'USER DETAILS',
  userDetailsNameLabel: 'NAME',
  userDetailsEmailLabel: 'EMAIL',
  userDetailsCompanyLabel: 'COMPANY',
  licenseRequestDetailsTitle: 'LICENSE REQUEST DETAILS',
  licenseRequestResolutionLabel: 'RESOLUTION',
  licenseRequestCountryLabel: 'COUNTRY',
  licenseRequestPeriodLabel: 'LICENSE PERIOD',
  licenseRequestDeliveryMethodLabel: 'DELIVERY METHOD',
  licenseRequestDeliveryDateLabel: 'DELIVERY DATE',
  licenseRequestChannelsLabel: 'CHANNELS',
  rightsLabel: 'RIGHTS',
  exclusiveLabel: 'EXCLUSIVE',
  nonExclusiveLabel: 'NON EXCLUSIVE',
  holdbackLabel: 'HOLDBACK',
  noHoldback: 'None',
  holdbackOneMonth: '1 Month',
  holdbackThreeMonths: '3 Months',
  holdbackSixMonths: '6 Months',
  holdbackNineMonths: '9 Months',
  notesTitle: 'NOTES',
  quoteNewStatus: 'New',
  quotePendingStatus: 'Pending',
  quoteAcceptedStatus: 'Accepted',
  quotePaidStatus: 'Paid',
  quoteCanceledStatus: 'Canceled',
  quoteCanceledStatusByUser: 'Canceled',
  quoteSaveButton: 'Save Request',
  rejectionReasonPlaceholder: 'Reason for rejection',
  addPricePlaceholder: 'Add price',
  addPriceButton: 'Add Price',
  updatePriceButton: 'Update Price',
  rejectButton: 'Reject',
  priceFieldValidation: 'Please enter a price',
  rejectionReasonFieldValidation: 'Please enter a reason for rejection',
  conflictsMessage: 'Conflicts with request(s): ',
  worldwide: 'Worldwide',
  updateLicensePeriod: 'Update License Period',
  periodNotAvailable: 'This period is not available, please try another one.',
  licensePeriodUpdateSuccessfully: 'License period update successfully',
  proposalRequestRejectSuccessfully: 'Proposal request has been rejected',
  videoDetailsOwnerLabel: 'OWNER',
};

export default proposalDialogConstantsEN;
